<template>
    <div class="faq">
        <div id="md" style="display: flex; justify-content: center; flex-direction: column; max-width: 900px; margin: 0 auto;" v-html="compiledMarkdown"></div>
    </div>
</template>
<script>
import kramed from 'kramed'
kramed.setOptions({
    renderer: new kramed.Renderer(),
    gfm: true,
    tables: true,
    breaks: false,
    pedantic: false,
    sanitize: true,
    smartLists: true,
    smartypants: false
});
export default {
    name: 'faq',
    data: function data() {
        return {
            uri: '',
            faqMd: ''
        }
    },
    computed: {
        compiledMarkdown: function() {
            return kramed(this.faqMd)
        }
    },
    created: function beforeCreate() {
        let _this = this
        _this.$http.get(_this.uri + '/FAQ.md')
            .then((res) => {
                _this.faqMd = res.data
            })
    }
}
</script>